export default __webpack_public_path__ + "static/media/cryptmo.c0bb992c.png";